import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { UserRole } from '../interface/user.interface';
import { UserState } from '../state/user.state';

@Directive({
  selector: '[accessControl]',
  standalone: true,
})
export class AccessControlDirective {
  @Input('accessControl') allowed?: UserRole[] = [];

  constructor(
    private tempRef: TemplateRef<any>,
    private viewRef: ViewContainerRef,
    private userState: UserState
  ) {}

  ngOnInit() {
    const hasAccess =
      !this.allowed ||
      this.allowed.length === 0 ||
      this.userState.userSetting.roles?.some((role) => this.allowed!.includes(role));

    if (hasAccess) this.viewRef.createEmbeddedView(this.tempRef);
    else this.viewRef.clear();
  }
}
